import * as angular from 'angular';
import toastr from 'toastr';

angular
  .module('screeningcanvas')
  .directive('paymentTermSelector', ['newApiClient', function (newApiClient) {
    return {
      restrict: 'A',
      scope: {
        optional: '=?',
        optionalText: "@",
      },
      template: '<option ng-if="optional" value="">{{ (!!optionalText) ? optionalText : "Nessuno" }}</option><option value="{{ item.id }}" ng-repeat="item in items">{{ item.label }}</option>',
      replace: false,
      controller: ['$scope', function ($scope) {
        $scope.items = [];

        $scope.fetch = function () {
          newApiClient.call(`
            query {
              paymentTerms {
                allPaymentTerms {
                  id
                  label
                }
              }
            }`,
            {},
          ).then(function (data) {
            $scope.items = data.paymentTerms.allPaymentTerms;
          }, function () {
            toastr.error("Impossibile caricare le scadenze pagamento");
          });
        };

        $scope.fetch();
      }],
    };
  }]);
